import React from "react";
import ReactApexChart from "react-apexcharts";

const PieChart = ({ reportData }) => {
  
  const data = {
    series: reportData && reportData[0]?.data,
    options: {
      chart: {
        type: "donut",
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
      labels:reportData && reportData[1]?.products,
    },
  };

  return (
    <div id="chart">
      <ReactApexChart
        options={data.options}
        series={data.series}
        type="donut"
        height={400}
      />
    </div>
  );
};

export default PieChart;
